import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { CompanyShare } from 'types/CompanyEntity'

interface DelistedHistoryTableRowProps {
    date: string | null
    share: CompanyShare
    locale: string
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const DelistedHistoryTableRow = ({
    date,
    share,
    locale,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: DelistedHistoryTableRowProps) => {
    const { t } = useTranslation()

    const delistedReason = share.delistedReason ? t(`site.instruments.${share.delistedReason}`) : null
    const delistedReasonText = delistedReason ? ` (${delistedReason})` : ''
    return (
        <TableRow>
            <TableCell>{formatDateYYYYMMDD(date, { locale })}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{share.symbol}</TableCell> : null}
            <TableCell>
                {t('pages.companies.history.delistingOf', { name: share.instrumentName })}
                {delistedReasonText}
            </TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
